import { useEffect, useState } from 'react';

export const COMPACT_VIEWPORT_QUERY = '(max-width: 767px)';

export const useCompactViewport = () => {
  const [compact, setCompact] = useState(
    () => window.matchMedia(COMPACT_VIEWPORT_QUERY).matches,
  );

  useEffect(() => {
    const media = window.matchMedia(COMPACT_VIEWPORT_QUERY);
    const onChange = (event: MediaQueryListEvent) => setCompact(event.matches);
    setCompact(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  return compact;
};
